import type { CoreModel } from '../schemas/model/model.ts'
import { SALESCORE_GOAL_MODEL } from './models/SALESCORE_GOAL_MODEL.ts'
import { SALESCORE_USER_GROUP_MODEL } from './models/SALESCORE_USER_GROUP_MODEL.ts'
import {
  getSalescoreUserGroupsWithParentsModel,
  SALESCORE_USER_GROUPS_WITH_PARENTS_MODEL,
} from './models/SALESCORE_USER_GROUPS_WITH_PARENTS_MODEL.ts'
import { SALESCORE_USER_MODEL } from './models/SALESCORE_USER_MODEL.ts'
import {
  getSalescoreUserWithGroupModel,
  SALESCORE_USER_WITH_GROUP_MODEL,
} from './models/SALESCORE_USER_WITH_GROUP_MODEL.ts'

// ELT で同期されるモデルと違い、組織の設定によらずコード側に常に存在するモデル。
// モデルの登録（ModelSearcher）と、名前だけを参照する側（OWD の閲覧制御）が別々に列挙していると、
// モデルを足したときに片方だけ古いまま残り、登録済みのモデルが未知モデル扱いされる。
// 列挙をこの配列 1 本に限定し、両者をここから導出する
const BUILT_IN_MODELS: ReadonlyArray<{
  readonly model: CoreModel
  // ラベルを組織のグループ階層名で差し替えた版を返す。name は基底モデルを spread するので変わらない
  readonly withUserGroupCategoryNames: ((userGroupCategoryNames: string[]) => CoreModel) | undefined
}> = [
  { model: SALESCORE_GOAL_MODEL, withUserGroupCategoryNames: undefined },
  { model: SALESCORE_USER_MODEL, withUserGroupCategoryNames: undefined },
  { model: SALESCORE_USER_GROUP_MODEL, withUserGroupCategoryNames: undefined },
  { model: SALESCORE_USER_WITH_GROUP_MODEL, withUserGroupCategoryNames: getSalescoreUserWithGroupModel },
  {
    model: SALESCORE_USER_GROUPS_WITH_PARENTS_MODEL,
    withUserGroupCategoryNames: getSalescoreUserGroupsWithParentsModel,
  },
]

export const BUILT_IN_MODEL_NAMES: readonly string[] = BUILT_IN_MODELS.map(({ model }) => model.name)

export const getBuiltInModels = (userGroupCategoryNames: string[]): CoreModel[] =>
  BUILT_IN_MODELS.map(
    ({ model, withUserGroupCategoryNames }) => withUserGroupCategoryNames?.(userGroupCategoryNames) ?? model,
  )
